import React from 'react';
import { Link } from 'react-router';

const NewRequestButton = (props) => (
  <Link to="/request" className="btn btn-block btn-primary btn-lg">
    New Request
    <div className="icon-white_add pull-right"></div>
  </Link>
);

export default NewRequestButton;



// WEBPACK FOOTER //
// ./src/components/Dashboard/NewRequestButton.js